﻿import _clone from 'lodash/clone'
export const clone = _clone
